import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { createExpressionBuilder, ScalarProvider, WeakCache, createVariable } from "../../../../../stream";
import { toStream } from "../toStream";
import { iText } from "../state/Text";
import { iCollection } from "../state/Collection";

const numberModified = WeakCache<api_cs.Cnumber__type__property, ScalarProvider<boolean>>((property) =>
	createVariable(
		toStream(property.properties.is_editable).stateSwitch({
			yes: ($) =>
				toStream($.properties.modified).stateSwitch({
					no: () => false,
					yes: () => true,
				})(),
			no: () => false,
		})(),
		false
	)
);
const fileModified = WeakCache<api_cs.Cfile__type__property, ScalarProvider<boolean>>((property) =>
	createVariable(
		toStream(property.properties.is_editable).stateSwitch({
			yes: ($) =>
				toStream($.properties.modified).stateSwitch({
					no: () => false,
					yes: () => true,
				})(),
			no: () => false,
		})(),
		false
	)
);
const stategroupModified = WeakCache<api_cs.Cstate_group__type__property, ScalarProvider<boolean>>((property) =>
	createVariable(
		toStream(property.properties.is_modified)
			.stateSwitch({
				yes: () => true,
				no: () => false,
			})
			.and(
				toStream(property.properties.is_set).stateSwitch({
					no: () => false,
					yes: ($) => nodeModified($.properties.state.ref.properties.node),
				})()
			)
			.pipe(([stategroup_modified, state_modified]) => stategroup_modified || state_modified)(),
		false
	)
);
const anyEntryModified = WeakCache<api_cs.Ccollection, ScalarProvider<boolean>>((property) =>
	createVariable(
		toStream(property.properties.entries)
			.map(([, entry]) =>
				toStream(entry.properties.location).stateSwitch({
					local: () => nodeModified(entry.properties.node),
					remote: ($) =>
						toStream($.properties.marked_for_deletion).stateSwitch({
							no: () => nodeModified(entry.properties.node),
							yes: () => false,
						})(),
				})()
			)
			.reduce((acc, $) => acc || $, false)(),
		false
	)
);

export const nodeModified: (node: api_cs.Cnode) => ScalarProvider<boolean> = WeakCache<
	api_cs.Cnode,
	ScalarProvider<boolean>
>((node) =>
	createVariable(
		toStream(node.properties.attributes)
			.map(([, attribute]) => {
				const attribute_type = attribute.properties.type.state;
				switch (attribute_type.name) {
					case "operation":
						return false;
					case "property": {
						const property_type = attribute_type.node.properties.type.state;
						switch (
							attribute_type.node.inferences.property_type().properties.type.state.node.output.value_source().variant
								.name
						) {
							case "derived":
								return false;
							case "base": {
								switch (property_type.name) {
									case "text":
										return iText(property_type.node).modified;
									case "number":
										return numberModified(property_type.node);
									case "file":
										return fileModified(property_type.node);
									case "group":
										return nodeModified(property_type.node.properties.node);
									case "state group":
										return stategroupModified(property_type.node);
									case "collection": {
										const size =
											property_type.node.inferences.collection_type().properties.ui.properties.size.state.name;
										return createExpressionBuilder(iCollection(property_type.node).modified)
											.and(anyEntryModified(property_type.node))
											.pipe(([collection_modified, any_entry_modified]) => {
												switch (size) {
													case "small":
														return collection_modified || any_entry_modified;
													case "large":
														return false;
												}
											})();
									}
								}
								break;
							}
						}
					}
				}
			})
			.reduce((acc, $) => acc || $, false)
			.pipe((modified) => {
				node.properties.modified.ensure(modified ? "yes" : "no", {});
				return modified;
			})(),
		false
	)
);

// const anyChangesOnStategroup = WeakCache<api_cs.Cstate_group__type__property, ScalarProvider<boolean>>((property) => {
// 	return createVariable(
// 		toStream(property.properties.is_modified)
// 			.stateSwitch({
// 				yes: () => true,
// 				no: () => false,
// 			})
// 			.and(
// 				toStream(property.properties.is_set).stateSwitch({
// 					no: () => false,
// 					yes: ($) => anyChangesOnNode($.properties.state.ref.properties.node),
// 				})()
// 			)
// 			.pipe(([stategroup_modified, state_modified]) => stategroup_modified || state_modified)(),
// 		false
// 	);
// });
// const anyChangesOnEntries = WeakCache<api_cs.Ccollection, ScalarProvider<boolean>>((property) => {
// 	return createVariable(
// 		toStream(property.properties.entries)
// 			.map(([, entry]) =>
// 				createExpressionBuilder(anyChangesOnNode(entry.properties.node)).pipe((any_changes) =>
// 					toStream(entry.properties.location).stateSwitch({
// 						local: () => false,
// 						remote: ($) =>
// 							toStream($.properties.marked_for_deletion).stateSwitch({
// 								no: () => any_changes,
// 								yes: () => false,
// 							})(),
// 					})()
// 				)()
// 			)
// 			.reduce((acc, $) => acc || $, false)(),
// 		false
// 	);
// });
// export const anyChangesOnNode: (node: api_cs.Cnode) => ScalarProvider<boolean> = WeakCache<
// 	api_cs.Cnode,
// 	ScalarProvider<boolean>
// >((node) => {
// 	return createVariable(
// 		toStream(node.properties.attributes)
// 			.map(([, attribute]) => {
// 				const attribute_type = attribute.properties.type.state;
// 				switch (attribute_type.name) {
// 					case "operation":
// 						return false;
// 					case "property": {
// 						const property_type = attribute_type.node.properties.type.state;
// 						switch (
// 							attribute_type.node.inferences.property_type().properties.type.state.node.output.value_source().variant
// 								.name
// 						) {
// 							case "derived":
// 								return false;
// 							case "base": {
// 								switch (property_type.name) {
// 									case "text":
// 										return textModified(property_type.node);
// 									case "number":
// 										return numberModified(property_type.node);
// 									case "file":
// 										return fileModified(property_type.node);
// 									case "group":
// 										return anyChangesOnNode(property_type.node.properties.node);
// 									case "state group":
// 										return anyChangesOnStategroup(property_type.node);
// 									case "collection":
// 										return createExpressionBuilder(collectionModified(property_type.node))
// 											.and(anyChangesOnEntries(property_type.node))
// 											.pipe(
// 												([collection_modified, any_changes_on_entries]) => collection_modified || any_changes_on_entries
// 											)();
// 								}
// 								break;
// 							}
// 						}
// 					}
// 				}
// 			})
// 			.reduce((acc, $) => acc || $, false)(),
// 		false
// 	);
// });
